import React from "react";
import "./remote-modeling-account.scss";

function RemoteModeling() {
    return (
        <div className="trinity-container">
            <h3 className={"main-heading"}>You do not have a Remote Modeling account.</h3>
            <p>To request an account,please call our Sales Team at <a  className={"main-heading"} href={"tel:+1(972)661-8881"}>+1 (972) 661-8881</a> or send an email
                to <a  className={"main-heading"} href={"email:breeze@trinityconsultants.com"}>breeze@trinityconsultants.com.</a></p>
        </div>
    );
}

export default RemoteModeling;
